<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{'is-sample': isSample, 'is-preview': !isSample}"
     >
  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-01'">
    <div class="flex">
      <div class="rirekisho-box1">
        <div class="rirekisho-header">
          <div class="title">이력서</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 현재
          </div>
        </div>
        <div class="rirekisho-profile"
             :data-highlight="highlightMessage"
             @click="goCardTo('profile')"
             :class="highLightClass('profile')">

          <div class="name flex" style="border-top: dotted 0px #000;height:100px;">
            <div class="label">성명</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc flex">
            <div class="birthday" :style="formatData.selFontStyle">
              <span class="year">{{ basicData.birthYear }}</span>년 <span class="month">{{ basicData.birthMonth }}</span>월 <span class="day">{{ basicData.birthDay }}</span>일（만 <span class="age">{{ age }}</span> 세）
            </div>

            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">남</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">여</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-photo"
           :data-highlight="highlightMessage"
           @click="goCardTo('id-photo')"
           :class="highLightClass('id-photo')">
        <div v-if="basicData.idPhotoSrc">
          <img :src="basicData.idPhotoSrc"
               alt="증명사진">
        </div>
        <div v-else>
          <div class="rirekisho-photo-inner">
            <p>증명사진
              <br>세로 36mm&#12316;40mm
              <br>가로 24mm&#12316;30mm
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             :data-highlight="highlightMessage"
             @click="goCardTo('address')"
             :class="highLightClass('address')">

          <div class="address flex" style="border-top: dotted 0px #000;">
            <div class="label">주소</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre :style="formatData.selFontStyle">{{ basicData.address1}}
{{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             :data-highlight="highlightMessage"
             @click="goCardTo('contacts')"
             :class="highLightClass('contacts')">
          <div class="tel flex">
            <div class="label">전화</div>
            <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
      <div class="contact-information contact-sub flex">
        <div class="contact-information-address"
             @click="goCardTo('address')"
             :class="highLightClass('address')">

<!--          <div class="address flex">-->
<!--            <div class="label">연락처</div>-->
<!--            <div class="input">-->
<!--              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.contactPostNumber) }}</div>-->
<!--              <div class="comment">(현주소 이외에 연락을 원하는 경우에만 입력)</div>-->
<!--              <pre :style="formatData.selFontStyle">{{ basicData.contactAddress1 }}-->
<!--{{ basicData.contactAddress2 }}</pre>-->
<!--              <div class="care-of"-->
<!--                   v-if="basicData.contactCareOf" :style="formatData.selFontStyle">{{ basicData.contactCareOf }} 方</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>

      </div>
    </div>
    <div class="rirekisho-table rirekisho-history-1"
         :data-highlight="highlightMessage"
         @click="goCardTo('edu-history')"
         :class="highLightClass(['edu-history','job-history'])">
      <table :class="{error:this.errorMessages.eduJobHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>학력・경력</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 19"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-02'">
    <div class="rirekisho-table rirekisho-skill"
         :data-highlight="highlightMessage"
         @click="goCardTo('license-history')"
         :class="highLightClass('license-history')">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>면허・자격증</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 9"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-pr" style="height:304px;">
      <div style="width: 100%;box-sizing: border-box;"
           :data-highlight="highlightMessage"
           @click="goCardTo('reason')"
           :class="highLightClass('reason')">
          <div  style="font-size: 12px;text-align: center !important;width: auto;border-bottom: solid 1px #000;padding: 4px;">성장과정</div>
          <div class="input" style="line-height: 1.7;padding: 4px;">
<!--        <div class="label2" >성장과정</div>-->
<!--        <div class="input">-->
          <pre ref="reason"
               :class="classObject.reason" :style="formatData.selFontStyle">{{ formatData.reason }}</pre>
        </div>
      </div>
    </div>
    <div style="margin-top: 8px;border: solid 2px rgba(0, 0, 0, 0.75);box-sizing: border-box;min-height: 304px;box-sizing: border-box;
   height: 208px;"
         :data-highlight="highlightMessage"
         @click="goCardTo('requests')"
         :class="highLightClass('requests')">
      <div style="font-size: 12px;text-align: center !important;width: auto;border-bottom: solid 1px #000;padding: 4px;">성격</div>
      <div class="input" style="line-height: 1.7;padding: 4px;">
        <pre ref="request"
             :class="classObject.request" :style="formatData.selFontStyle">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>

  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-03'">

      <div class="rirekisho-pr" style="height:285px;">
          <div style="width: 100%;box-sizing: border-box;"
               :data-highlight="highlightMessage"
               @click="goCardTo('reason2')"
               :class="highLightClass('reason2')">
              <div style="font-size: 12px;text-align: center !important;width: auto;border-bottom: solid 1px #000;padding: 4px;">학교생활</div>
              <div class="input" style="line-height: 1.7;padding: 4px;">
        <pre ref="reason2"
             :class="classObject.reason2" :style="formatData.selFontStyle">{{ formatData.reason2 }}</pre>
              </div>
          </div>
      </div>
      <div style="margin-top: 8px;border: solid 2px rgba(0, 0, 0, 0.75);box-sizing: border-box;min-height: 285px;box-sizing: border-box;
height: 208px;"
           :data-highlight="highlightMessage"
           @click="goCardTo('reason3')"
           :class="highLightClass('reason3')">
          <div style="font-size: 12px;text-align: center !important;width: auto;border-bottom: solid 1px #000;padding: 4px;"
          >지원동기</div>
          <div class="input" style="line-height: 1.7;padding: 4px;">
      <pre ref="reason3"
           :class="classObject.reason3" :style="formatData.selFontStyle">{{ formatData.reason3 }}</pre>
          </div>
      </div>
      <div style="margin-top: 8px;border: solid 2px rgba(0, 0, 0, 0.75);box-sizing: border-box;min-height: 285px;box-sizing: border-box;
height: 208px;"
           :data-highlight="highlightMessage"
           @click="goCardTo('reason4')"
           :class="highLightClass('reason4')">
          <div style="font-size: 12px;text-align: center !important;width: auto;border-bottom: solid 1px #000;padding: 4px;">성장목표</div>
          <div class="input" style="line-height: 1.7;padding: 4px;">
      <pre ref="reason4"
           :class="classObject.reason4" :style="formatData.selFontStyle">{{ formatData.reason4 }}</pre>
          </div>
      </div>
  </div>

</div>
</template>
<script>
import RirekishoPreviewMixinKr2 from '@/mixins/rirekishokr2-preview-mixin'
export default {
  name: 'rirekishoPreview',
  props: {
    formatId: {
      type: String
    }
  },
  mixins: [RirekishoPreviewMixinKr2],
  data: function () {
    return {
      maxEduJobRows: 19,
      maxLicenseRows: 9,
      textareaMaxHeights: {
        reason: 280,
        reason2: 250,
        reason3: 250,
        reason4: 250,
        request: 280
      }
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
        this.adjustFontSize('reason2')
        this.adjustFontSize('reason3')
        this.adjustFontSize('reason4')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  },
  watch: {
    'formatData': function () {
      this.checkValid()
    }
  }
}
</script>
